export const PROMOTIONS_PATH = "/api/promotions";
